import React, { useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { validateShareAccess } from '../../../../../utils/shareHelpers';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import { Map, MapPin, Route, Settings, X } from 'lucide-react';
import { db, storage, auth } from '../../../../../config/firebase';
import { Button } from '../../../../../components/common/Button';
import { LoadingSpinner } from '../../../../../components/common/LoadingSpinner';
import { Toast } from '../../../../../components/common/Toast';
import { logError, logInfo } from '../../../../../utils/logger';
import Header from './components/Header';
import MapContainer from './components/MapContainer';
import Sidebar from './components/Sidebar';
import ErrorDisplay from './components/ErrorDisplay';
import useSharedMapData from './hooks/useSharedMapData';

export const SharedMapView = () => {
  const { shareId } = useParams();
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(true);
  const [visibilityState, setVisibilityState] = useState({
    poiTypes: {},
    routes: {},
    lineWidth: 4,
    lineOpacity: 0.8,
    poiSizeFar: 16,
    poiSizeMedium: 24,
    poiSizeClose: 32
  });
  const [toast, setToast] = useState(null);
  const mapRef = useRef(null);
  
  // Get survey data using the hook
  const { data: surveyData, loading, error, pois, routes, files, mapInstance, setMapInstance } = useSharedMapData(shareId);

  const handleVisibilityChange = (newState) => {
    setVisibilityState(newState);
  };

  return (
    <div className="min-h-screen bg-[#3D3F42] flex flex-col">
      {/* Header */}
      <Header 
        surveyData={surveyData}
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
      />

      {/* Main Content */}
      <div className="flex-1 flex">
        {/* Map Container */}
        <div className="flex-1 relative">
          {loading && <LoadingSpinner />}
          {error && <ErrorDisplay error={error} />}
          {!loading && !error && (
            <MapContainer
              pois={pois}
              routes={routes}
              files={files}
              visibilityState={visibilityState}
              onMapLoad={setMapInstance}
              surveyData={surveyData}
            />
          )}
        </div>

        {/* Sidebar */}
        {showSidebar && (
          <Sidebar
            map={mapInstance}
            pois={pois}
            routes={routes}
            onVisibilityChange={handleVisibilityChange}
            visibilityState={visibilityState}
            onClose={() => setShowSidebar(false)}
            surveyData={surveyData}
          />
        )}
      </div>

      {/* Toast Notifications */}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
};

export default SharedMapView;